<!--suppress JSUnresolvedFunction, JSUnresolvedVariable -->
<template>
  <main
    class="flex flex-col justify-between p-0 m-0 bg-honkgreen-600 md:mt-32 mt-24"
  >
    <div class="md:p-64 px-16 py-64 footer-content-width">
      <honk-logo-vue class="mb-64" />
      <div class="flex md:flex-row flex-col flex-wrap justify-between">
        <link-category
          v-for="category in linkCategories"
          :key="category.title"
          :title="category.title"
          :links="category.links"
          class="mb-40 mr-40"
        />
        <service-from />
      </div>
    </div>
    <schibsted-banner />
  </main>
</template>

<script setup>
  import { inject } from 'vue'
  import HonkLogoVue from './assets/HonkLogo.vue'
  import ServiceFrom from './ServiceFrom.vue'
  import SchibstedBanner from './SchibstedBanner.vue'
  import LinkCategory from './LinkCategory.vue'
  import { configInjectionKey, fluentInjectionKey } from './injectionKeys.js'

  const fluent = inject(fluentInjectionKey)
  const config = inject(configInjectionKey)

  const {
    privacySettingsUrl,
    privacyDeclarationUrl,
    schibstedAccountClientId,
    topLevelDomain,
  } = config

  const aboutCategory = {
    title: fluent('about-the-service'),
    links: [
      {
        title: fluent('about-honk'),
        link: '/about',
      },
      {
        title: fluent('our-providers'),
        link: '/providers',
      },
      {
        title: fluent('user-terms'),
        link: '/user-terms',
      },
    ],
  }

  const contactCategory = {
    title: fluent('contact'),
    links: [
      {
        title: fluent('contact-us'),
        link: '/contact',
      },
      {
        title: fluent('faq'),
        link: '/faq',
      },
    ],
  }

  const privacyCategory = {
    title: fluent('privacy'),
    links: [
      {
        title: fluent('privacy-declaration'),
        link: privacyDeclarationUrl,
        newTab: true,
      },
    ],
  }

  // https://docs.schibsted.io/privacy-settings/privacy-settings-ui/#providing-information-about-the-traffic-source
  const openPrivacySettings = ({
    environmentId, // can be extracted from Pulse configuration; only if user is not logged in
    clientId, // client Id of your service
    brandName, // lowercased name of your service
    linkPlacement, // link placement in your application for UTM tags, header or footer
    referrer, // optional return link to your service
    state, // optional state for return purposes
  }) => {
    // URL of the appropriate PS UI instance, e.g. https://privacysettings.schibsted.no/
    const urlObject = new URL(privacySettingsUrl)

    // your service-related data
    urlObject.searchParams.append('client_id', clientId)
    urlObject.searchParams.append('referrer', referrer || window.location.href)
    if (state) urlObject.searchParams.append('state', state)

    // identifier if user is not logged in
    if (environmentId) {
      urlObject.searchParams.append('environment_id', environmentId)
    }

    // UTM tags
    urlObject.searchParams.append('utm_source', brandName)
    urlObject.searchParams.append('utm_medium', linkPlacement)

    window.location.href = urlObject.href
  }

  privacyCategory.links.push({
    title: fluent('privacy-settings'),
    onClick: async () => {
      const isLoggedIn = window.Identity
        ? await window.Identity.isLoggedIn()
        : true
      const environmentId =
        !isLoggedIn && window.psi
          ? await window.psi.pulseTracker.getEnvironmentId()
          : undefined
      openPrivacySettings({
        privacySettingsUrl,
        environmentId,
        clientId: schibstedAccountClientId,
        brandName: 'honk',
        linkPlacement: 'footer',
      })
    },
  })

  if (topLevelDomain === 'se') {
    privacyCategory.links.push({
      title: fluent('cookie-settings'),
      onClick: () => {
        window._scc_.showPrivacyManager()
      },
    })
  }

  const linkCategories = [aboutCategory, contactCategory, privacyCategory]
</script>
<style scoped>
  .footer-content-width {
    max-width: 1050px;
  }
</style>
